export default __webpack_public_path__ + "static/media/UniversLTStd-BoldExObl.92686432.otf";